import React from 'react'
import { Image, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { source } from 'react-aim';
import { toastr } from 'react-redux-toastr';
import noInvite from './../../../../../images/grafix-banner/undraw_hire.svg'
import CommonTable from '../../../../drive/Table/TableLayout';
import InvitationListViewJSON from './InvitationListViewJSON.json'
import InvitationList from "./InvitationList.json"

let timer = 0;
let delay = 200;
let prevent = false;



@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name);
    }
})

class InvitationListView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // tableHeader: InvitationListViewJSON,
            _limit: 10,
            _sort: "firstName"
        }
    }


    redirectUserInvite() {
        const { history } = this.props;
        history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/addUser/addUserInInviteList/${this.props.selectedSubOrg ? this.props.selectedSubOrg._id : this.props.selectedOrganisation.id}/${this.props.selectedSubOrg && this.props.selectedSubOrg.parentOrganizationId ? this.props.selectedSubOrg.parentOrganizationId : this.props.selectedOrganisation.id}`);
    }

    handleClick(event, user, index) {
        let thisClick = this;
        timer = setTimeout(function () {
            if (!prevent) {
                thisClick.cardClick(user, index);
            }
            prevent = false;
        }, delay);
    }

    async cardClick(user, index) {
        dispatch.invite.updateStateForResource(user);
        dispatch.organizationUnit.showResourecePane("Invited");
        dispatch.lifeCycle.splitAt("60%")
        dispatch.lifeCycle.setLibraryCardIndex(index)
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.users.userDeactivateModal(false);
        dispatch.organizationUnit.showDeleteDisabled(true);
    }

    handleDoubleClick(user, index) {
        clearTimeout(timer);
        prevent = true;
        this.doDoubleClickAction(user, index);
    }

    doDoubleClickAction(user, index) {
        this.cardClick(user, index);
        dispatch.lifeCycle.splitAt("60%");
    }

    onQueryChange = async (query) => {
        let payload = {
            query: query,
            organizationId: this.props.match.params.workspaceId,
            referenceId: this.props.match.params.teamId
        };
        await dispatch.invite.getInvitesAsync(payload);
    };


    addColumn = (newColumns) => {
        if (newColumns) {
            this.setState({ tableHeader: newColumns })
        }
    };
    handleTableComponent = (event, item, data) => {

    }
    handleDropDownItem = (event, type, data, clickedCount) => {
        if (type.text === "Resend") {
            this.resendInvitation(event, data)
        }
        if (type.text === "Delete") {
            this.deleteInvitaion(event, data)
        }
        if (type.text === "View") {
            this.handleClick(event, data)
        }
    }
    resendInvitation(event, invite) {
        let message = <div className="confirmMessage">
            <h3>Resend Invitation</h3>
            <label>{invite.email}</label>
            <p>Are you sure that you wish to resend this invitation?</p>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                let organizationObj = {
                    "name": this.props.match.params.workspaceId === this.props.match.params.teamId.toString() ?
                        this.props.selectedOrganisation.name : this.props.selectedSubOrg && this.props.selectedSubOrg.name,
                    "entityName": this.props.match.params.workspaceId === this.props.match.params.teamId.toString() ?
                        "Workspace" : 'Team'
                }
                let subject = this.props.match.params.workspaceId.toString() !== this.props.match.params.teamId.toString() ?
                    `You have been Invited to join the "${this.props.selectedSubOrg.name}" Team for "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`
                    : `You have been Invited to join the "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`

                let emailObject = {
                    templateName: "resendInviteMail",
                    toEmail: invite.email,
                    invite: invite,
                    invitationCode: invite._id,
                    fromUser: this.props.user,
                    organization: organizationObj,
                    subject: subject
                }
               await dispatch.invite.resendInvitation(emailObject);
                // dispatch.invite.updateInviteUser(emailObject);
                dispatch.organizationUnit.showResourecePane(null)
                let query = {
                    $sort: { createdAt: 1 },
                    $skip: 0,
                    $limit: this.props.teamsListViewFlag ? 10 : 50
                }
                let payload = {
                    query: query,
                    organizationId: this.props.match.params.workspaceId,
                    referenceId: this.props.match.params.teamId
                };
                await dispatch.invite.getInvitesAsync(payload);
            }
        });
    }
    async deleteInvitaion(event, invite) {
        let message = <div className="confirmMessage">
            <h3>Delete Invitation</h3>
            <label>{invite.firstName} {invite.lastName}</label>
            <p>Are you sure that you wish to delete this invitation?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                await dispatch.invite.deleteInvitaionAsync(invite);
                dispatch.organizationUnit.showResourecePane(null);
                let payload = {
                    query: {
                        _limit: 10,
                        _sort: "firstName"
                    },
                    organizationId: this.props.match.params.workspaceId,
                    referenceId: this.props.match.params.teamId
                };
                await dispatch.invite.getInvitesAsync(payload);
                
            }
        });
    }

    componentWillMount() {
        dispatch.lifeCycle.setLibraryCardIndex(null);
        dispatch.organizationUnit.showDeleteDisabled(false)

        if (!this.props.selectedSubOrg || this.props.selectedSubOrg === null) {
            dispatch.organizationUnit.getSubOrgByIdAsync(this.props.match.params.teamId);
        }
    }

    render() {
        let orgId = this.props.match.url.split("/")
        let tableHeader
        if(this.props.selectedOrganisation.role === "workspaceOwner") {
            tableHeader = InvitationListViewJSON
        }
        if(this.props.selectedOrganisation.role === "Manager") {
            if(orgId[4] === orgId[7]) {
                tableHeader = InvitationList
            }
            else {
                tableHeader = InvitationListViewJSON
            }
        }

        return (
            <div>
                {this.props.invites && this.props.invites.data && this.props.invites.data.length > 0 ?
                    <CommonTable
                        tableName={null}
                        tableHeader={tableHeader}
                        listData={this.props.invites && this.props.invites.data}
                        totalCount={this.props.invites && this.props.invites.total}
                        loading={this.props.loaderForAllAccount}
                        onQueryChange={this.onQueryChange}
                        searchable={false}
                        addColumn={this.addColumn}
                        handleDropDownItem={this.handleDropDownItem}
                        selection={true}
                        limit={this.state._limit}
                        sort={this.state._sort}
                    /> :
                    <div className="w_50 text-center mar_0_auto pad_20">
                        <Image src={noInvite} /> <br />
                        <strong as="h3" > No users to display.</strong><br /><br />
                        <strong > Communities are all about communicating, <br /> Collaborating and Managing. Start creating your <br />own teams.</strong><br /><br />
                        <Button className="button-submit" onClick={(e) => this.redirectUserInvite(e)} >Add / Invite Users</Button>
                    </div>
                }
            </div>
        )
    }
}

export default withRouter(InvitationListView)